import { useEffect, useState } from 'react';

import { AnalyticSources } from 'src/app/analytics/analyticsEvents';
import { useSegmentEvent } from 'src/app/hooks/useSegmentEvent';
import type { Order } from 'src/app/types/orders';
import { ORDER_STATUSES } from 'src/consts';

export const useOrderHistoryAnalytics = (ordersActive: Order[] | undefined) => {
  const dispatchViewYourOrdersEvent = useSegmentEvent('viewYourOrders', { shouldTrackOnMount: false });
  const dispatchViewFailedDeliveryRescheduleEvent = useSegmentEvent('viewFailedDeliveryReschedule', {
    shouldTrackOnMount: false,
  });
  const [hasEventBeenSent, setHasEventBeenSent] = useState(false);
  useEffect(() => {
    if (!hasEventBeenSent) {
      if (ordersActive) {
        dispatchViewYourOrdersEvent({
          failed_orders: ordersActive?.filter(activeOrder => activeOrder.status === ORDER_STATUSES.postponed).length,
        });
        // If the orders contains at least one postponed order
        const firstPostponedOrder = ordersActive.find(activeOrder => activeOrder.status === ORDER_STATUSES.postponed);
        if (firstPostponedOrder) {
          dispatchViewFailedDeliveryRescheduleEvent({
            source: AnalyticSources.orders,
            order_id: firstPostponedOrder.id,
          });
        }
        setHasEventBeenSent(true);
      }
    }
  }, [dispatchViewFailedDeliveryRescheduleEvent, dispatchViewYourOrdersEvent, hasEventBeenSent, ordersActive]);
};
